import { useMapStore, useUserRolePermissionStore } from 'contexts/RootStore.context';
import useDevice from 'hooks/useDevice';
import { useEffect } from 'react';
import NoPermissionsPage from 'views/NoPermissionsPage';
import { DisplaySetting } from './components/Filter/DisplaySetting';
import MapContainerRefProvider from './utils/mapContainerRef.context';
import { MapContainerStyle } from './Styled';
import { MapContainerWrapper } from './layers/MapContainerWrapper';
import { Filter } from './components/Filter/Filter';
import { observer } from 'mobx-react';
import { Vertical } from 'gls';


export const MapPage = observer(() => {
  const { isMobileDevice } = useDevice();
  const { canViewUsers, canViewAssets, canViewDevices } = useUserRolePermissionStore()
  const { loadData, reset, abortController } = useMapStore()

  useEffect(() => {
    if (canViewAssets || canViewUsers || canViewDevices) {
      loadData()
    }

    return () => {
      abortController.abort();
      reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!canViewAssets && !canViewUsers && !canViewDevices) {
    return <NoPermissionsPage />
  }

  return (
    <MapContainerRefProvider>
      <Filter />
      {!isMobileDevice && <DisplaySetting />}
      <Vertical sizing="stretch" className={MapContainerStyle}>
        <MapContainerWrapper />
      </Vertical>
    </MapContainerRefProvider>
  );
})